
export interface DocumentSizeDetails {
    docId: string;
    actualSize: number;
    humaneActualSize: string;
    allocatedSize: number;
    humaneAllocatedSize: string;
}